const TemporaryFileUploadMethod = {
  PreSigned: "PRE_SIGNED"};

export { TemporaryFileUploadMethod };
//# sourceMappingURL=temporary-file-upload-method.mjs.map
